// src/components/intake/IntakeFilingHistory.js
//
// Ticket 066 (Advisor Intake I6), screen 5.1. Have you filed a Spanish return
// before? Yes/No (required). The gestor question appears only for "Yes" and is
// also required. No Skip and no "Not sure". Nothing is stored here: answers go out
// through onChange({ filed } | { gestor }). Options come from slotConfig via
// intakeConfig.

import React from 'react'
import IntakeFollowUp from './IntakeFollowUp'
import { FILING_OPTIONS, GESTOR_QUESTION, GESTOR_OPTIONS } from '../../lib/intake/intakeConfig'
import { known } from '../../lib/intake/section1Facts'

const asFact = (value) => (value === null || value === undefined ? undefined : known(value))

export default function IntakeFilingHistory({ filing, onChange }) {
  return (
    <div className="u-stack-sm">
      <IntakeFollowUp
        options={FILING_OPTIONS}
        fact={asFact(filing.filed)}
        onPick={(fact) => onChange({ filed: fact.value })}
      />
      {filing.filed === true && (
        <IntakeFollowUp
          sub
          question={GESTOR_QUESTION}
          options={GESTOR_OPTIONS}
          fact={asFact(filing.gestor)}
          onPick={(fact) => onChange({ gestor: fact.value })}
        />
      )}
    </div>
  )
}
